import React, { useState } from "react";
import {
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignMiddleIcon,
  AlignRightIcon,
  BoldIcon,
  CodeIcon,
  ColorLensArrowIcon,
  ColorLensIcon,
  ImageIcon,
  ItalicIcon,
  ProfileEditIcon,
  UnderlineIcon,
} from "../common/Icon";

import ColorPickerModal from "../common/ColorPickerModal";
import RichTextEditor from "react-rte";

const WorkflowProfileNote = () => {
  const [color, setColor] = useState("#000"); // Default color
  const [showColorModal, setShowColorModal] = useState(false); //Color Modal
  const [isItalic, setIsItalic] = useState(false);

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  const changeTextColor = () => {
    document.getElementById("text-to-change").style.color = color;
    setShowColorModal(true);
  };

  const textStyles = {
    fontStyle: isItalic ? "italic" : "normal",
  };
  const toggleItalic = () => {
    setIsItalic(!isItalic);
  };

  const [value, setValue] = useState(RichTextEditor.createEmptyValue());

  const onChange = (newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="px-6 pt-[43px] pb-6 h-full flex flex-col relative ">
        <div className=" flex flex-col flex-grow justify-between">
          <div className=" h-[300px] 2xl:h-[370px] rounded-2xl border border-solid border-[rgba(0,_0,_0,_0.20)] overflow-x-auto w-full md:w-auto overflow-hidden">
            <RichTextEditor value={value} onChange={onChange} />
            {/* <div className="px-[42px] py-4 overflow-x-auto overflow_x_scroll_style rounded-md bg-[rgba(111,_106,_248,_0.05)]  w-[320px]  xs:w-[350px] md:overflow-x-visible md:w-auto">
              <div className="flex items-center  ">
                <button>
                  <CodeIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <BoldIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button onClick={toggleItalic}>
                  <ItalicIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <UnderlineIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <AlignLeftIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <AlignRightIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <AlignJustifyIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <AlignMiddleIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button>
                  <ImageIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[14px]"></span>
                <button
                  onClick={changeTextColor}
                  className=" flex items-center relative"
                >
                  <ColorLensIcon />
                  <span className="pl-1">
                    <ColorLensArrowIcon />
                  </span>

                  <div className=" absolute top-[30px] right-[30%]">
                    {showColorModal && (
                      <ColorPickerModal
                        changeTextColor={changeTextColor}
                        handleColorChange={handleColorChange}
                        color={color}
                      />
                    )}
                  </div>
                </button>
              </div>
            </div>
            <div onClick={() => setShowColorModal(false)} className=" bg-white">
              <textarea
                style={textStyles}
                id="text-to-change"
                className="w-full p-2 outline-none resize-none text-black font-normal text-sm 3xl:text-[16px]"
                cols="50"
                rows="18"
              ></textarea>
            </div> */}
          </div>
          <div className="flex gap-5 py-7 xl:pt-[110px] xl:pb-6 justify-end">
            <button className="text-[14px] font-bold text-primary rounded-[26px] border border-solid border-primary outline-none p-[8px_20px] flex items-center gap-[10px] hover:border-transparent hover:bg-primary hover:text-white information_edit_button duration-200">
              <span className="information_edit_icon w-[16px] h-[16px]">
                <ProfileEditIcon />
              </span>
              Edit
            </button>
            <button
              type="submit"
              className="text-[14px] font-semibold text-white rounded-[26px] border-transparent  outline-none p-[14px_25px] xl:w-[90px] bg-primary  hover:bg-primary/80 duration-200">
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkflowProfileNote;
